export const FETCH_USER = 'fetch_user';
export const FETCH_USER_ERROR = 'fetch_user_error';